import React from "react";
import Cube from "./components/Cube";
import { Container } from "react-bootstrap";
import "./style.scss";
import { GiRecycle } from "react-icons/gi";
import { TfiStatsDown } from "react-icons/tfi";
import { TfiStatsUp } from "react-icons/tfi";
import { MdOutlineEnergySavingsLeaf } from "react-icons/md";

import { IconBase } from "react-icons";
const WhyRecycling = () => {
  return (
    <div className="section why-recycling-page" id="why-recycle">
      <Container>
        <div className="main-heading">
          <h1>Why recycling is important!</h1>
          <p>
            recycling can be important because a difrent reason it depend on our
            vision edge.
          </p>
        </div>
        <div className="cube-parent">
          <div className="left">
            <div className="cube">
              <GiRecycle size={45} color="#009f3b" />
              <h3>Resource Conservation</h3>
              <p>
                Recycling saves valuable natural resources like minerals and
                water, reducing the need for resource extraction and preserving
                ecosystems.
              </p>
            </div>
            <div className="cube">
              <MdOutlineEnergySavingsLeaf size={45} color="#009f3b" />
              <h3>Energy Savings</h3>
              <p>
                Recycling consumes less energy than producing goods from raw
                materials, leading to lower greenhouse gas emissions and a
                smaller carbon footprint.
              </p>
            </div>
          </div>
          <div className="right">
            <div className="cube">
              <TfiStatsDown size={45} color="#009f3b" />
              <h3>Waste Reduction</h3>
              <p>
                By diverting waste from landfills, recycling minimizes
                environmental impact, prevents soil and water contamination, and
                decreases greenhouse gas emissions.
              </p>
            </div>
            <div className="cube">
              <TfiStatsUp size={45} color="#009f3b" />
              <h3>Economic Benefits</h3>
              <p>
                Recycling fosters a circular economy, creating jobs, lowering
                waste disposal costs, and promoting sustainable resource use for
                long-term economic gains.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default WhyRecycling;
